module.exports = __webpack_public_path__ + "static/media/girl-22.fe02e4e8.svg";